import { jsx as e, jsxs as t } from "react/jsx-runtime";
import { m as a } from "motion/react";
import { useAnimateFadeIn as o } from "../../../animation/animation.js";
import r from "./hero-text-block.module.less.js";
const p = ({ title: n, preamble: i }) => {
  const s = o({ whileInView: !0, easing: "easeInOut" });
  return /* @__PURE__ */ e(a.section, { ...s, className: ["max-width padded-sides", r.wrapper].join(" "), children: /* @__PURE__ */ t("div", { className: [r.innerWrapper, "text-max-width"].join(" "), children: [
    /* @__PURE__ */ e("h1", { children: n }),
    i && /* @__PURE__ */ e("p", { className: "body-l", children: i })
  ] }) });
};
export {
  p as HeroTextBlock,
  p as default
};
